import { createSlice } from '@reduxjs/toolkit'

const arbitriSlice = createSlice({
  name: 'arbitri',
  initialState: {},
  reducers: {
    setArbitro(state, action) {
      state.arbitro = action.payload
    },
    setArbitroField(state, action) {
      if (!state.arbitro) state.arbitro = {}
      state.arbitro[action.payload.field] = action.payload.value
    },
  },
})

export const { setArbitro, setArbitroField } = arbitriSlice.actions

export default arbitriSlice.reducer
